import { useQuery } from "@tanstack/react-query";
import { ApiError } from "@/api/client";
import { listAudit, type AuditEntry } from "@/api/audit";
import { useSession } from "@/store/session";

export const AUDIT_TAIL_KEY = (limit: number) => ["audit-tail", limit] as const;

export function useAuditTail(limit = 10) {
  const isAdmin = useSession((state) => state.user?.role === "admin");
  return useQuery<AuditEntry[], Error>({
    queryKey: AUDIT_TAIL_KEY(limit),
    queryFn: () => listAudit({ limit }),
    enabled: isAdmin,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 401) return false;
      return failureCount < 1;
    },
    staleTime: 30_000,
  });
}
